/**
 * Blueprint for the Api Connection entity.
 */
export class ApiConnection {
  public branch?: string;
  public username?: string;
  public password?: number;
  public bankAccountTypeId?: any;

  public constructor(apiConnection?: any) {
    this.branch = apiConnection?.branch;
    this.username = apiConnection?.username;
    this.password = apiConnection?.password;
    this.bankAccountTypeId = apiConnection?.bankAccountTypeId;
  }
}
